import React from "react";
import Question, { QuestionType } from "../../types/Question";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  TextField,
} from "@material-ui/core";

interface IProps {
  index: number;
  question: Question;
  onChange: (index: number, question: Question) => void;
}

export default function QuestionMultipleChoice(props: IProps) {
  const { index, question, onChange } = props;
  const [showPrompt, setShowPrompt] = React.useState(false);

  React.useEffect(() => {
    setShowPrompt(false);
  }, [question]);

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    let answer = event.target.value;
    for (const a of question.answers) {
      if (a.choiceText === answer) {
        a.selectedAnswer = true;
        if (
          question.questionType === QuestionType.WithResponse &&
          !a.correctAnswer
        ) {
          setShowPrompt(true);
        } else {
          setShowPrompt(false);
        }
      } else {
        a.selectedAnswer = false;
      }
    }
    onChange(index, question);
  }

  function handlePromptBlur(event: React.ChangeEvent<unknown>) {
    let val = (event.target as HTMLInputElement).value;
    for (const a of question.answers) {
      if (a.selectedAnswer) {
        a.promptAnswer = val;
      }
    }
    onChange(index, question);
  }

  function handleCheck(event: React.ChangeEvent<HTMLInputElement>) {
    let checked = event.target.checked;
    let value = event.target.value;
    for (const a of question.answers) {
      if (a.choiceText === value) {
        a.selectedAnswer = checked;
      }
    }
    onChange(index, question);
  }

  function getAnswers() {
    switch (question.questionType) {
      case QuestionType.MultipleChoiceOne:
      case QuestionType.TrueFalse:
      case QuestionType.WithResponse:
      case QuestionType.WithResponseHr:
        return (
          <RadioGroup onChange={handleChange}>
            {question?.answers?.map((answer) => (
              <FormControlLabel
                value={answer.choiceText}
                control={<Radio checked={answer.selectedAnswer ?? false} />}
                label={answer.choiceText}
                style={{ flex: 1 }}
                key={answer.choiceText}
              />
            ))}
          </RadioGroup>
        );
      case QuestionType.MultipleChoiceMulti:
        return (
          <>
            {question?.answers?.map((answer) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={answer.selectedAnswer ?? false}
                    onChange={handleCheck}
                    value={answer.choiceText}
                    color="primary"
                  />
                }
                label={answer.choiceText}
                style={{ width: "100%" }}
                key={answer.choiceText}
              />
            ))}
          </>
        );
      default:
        return null;
    }
  }

  return (
    <>
      {getAnswers()}
      {showPrompt ? (
        <>
          <h4 style={{ marginBottom: 8 }}>{question.incorrectPrompt}</h4>
          <TextField
            multiline
            required
            placeholder="This field is required"
            rows="6"
            variant="outlined"
            fullWidth
            onBlur={handlePromptBlur}
          />
        </>
      ) : null}
    </>
  );
}
